import { Box } from "@mui/material";
import { useContext } from "react";

import CurateTreeItem from "./CurateTreeItem";
import DefaultTreeItem from "./DefaultTreeItem";
import TreeContext from "./treeContext";

export default function CustomTreeList({
  expanded,
  nodes,
  position = null,
  indentLevel = null,
}) {
  const { isCurate } = useContext(TreeContext);
  return (
    <div>
      {nodes.map((n, i) => {
        const isExpanded = expanded.includes(n.id);
        const pos = `${position ?? ""}${i + 1}.`;
        const indent =
          isCurate && n.original?.itemExtra?.curate?.show === 0
            ? `${indentLevel}`
            : `${indentLevel ?? ""}${i + 1}.`;

        return (
          <Box key={n.id}>
            {isCurate &&
            n?.original?.itemExtra?.curate &&
            n?.original?.itemExtra?.curate?.show === 1 ? (
              <CurateTreeItem
                node={n}
                position={pos}
                isExpanded={isExpanded}
                indentLevel={indent}
              />
            ) : (
              <DefaultTreeItem
                node={n}
                position={pos}
                isExpanded={isExpanded}
                indentLevel={indent}
              />
            )}
            {isExpanded ? (
              <CustomTreeList
                nodes={n.items}
                position={pos}
                indentLevel={indent}
                expanded={expanded}
              />
            ) : null}
          </Box>
        );
      })}
    </div>
  );
}
